import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useEffect, useRef, useState } from 'react';
import SwiperCore, { Autoplay, Navigation, Thumbs, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { AutoplayOptions, Swiper as SwiperType } from 'swiper/types';
import 'swiper/scss';

import EcoImg from 'eco-design/base/eco-img';
import { getIsPadWidth } from '@elem/utils/devices';
import { useSwiperAutoplayOnVisible } from 'eco-design/sections/eco-section-carousel/hooks/useSwiperAutoplayOnVisible';
import { useAnimationNavigationRight } from 'eco-design/sections/eco-section-carousel/hooks/useAnimationNavigationRight';
import gtm from 'eco-design-reliance/gtm';
SwiperCore.use([Thumbs]);
const D: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.D');
    const [enter, setEnter] = useState(false);
    const swiperRef = useRef<SwiperType>();
    const [active, setActive] = useState(0);
    const [spaceBetween, setSpaceBetween] = useState(34);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const isPad = getIsPadWidth();


    const items = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763520987762/lb-1.jpg',
            h5: "https://websiteoss.ecoflow.com/upload/image/1764243386112/1.png",
            // padImg: ['https://websiteoss.ecoflow.com/upload/image/1763521028193/1-a.jpg', 'https://websiteoss.ecoflow.com/upload/image/1763521028327/1-b.jpg'],
            slImg: 'https://websiteoss.ecoflow.com/upload/image/1763521654931/sl-1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763521013381/lb-2.jpg',
            h5: "https://websiteoss.ecoflow.com/upload/image/1764243386676/2.png",
            // padImg: ['https://websiteoss.ecoflow.com/upload/image/1763521036554/2-a.jpg', 'https://websiteoss.ecoflow.com/upload/image/1763521037021/2-b.jpg'],
            slImg: 'https://websiteoss.ecoflow.com/upload/image/1763521654262/sl-2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763521013489/lb-3.jpg',
            h5: "https://websiteoss.ecoflow.com/upload/image/1764243386261/3.png",
            // padImg: ['https://websiteoss.ecoflow.com/upload/image/1763521037438/3-a.jpg', 'https://websiteoss.ecoflow.com/upload/image/1763521038044/3-b.jpg'],
            slImg: 'https://websiteoss.ecoflow.com/upload/image/1763521654461/sl-3.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    const lines = t(isPad ? 'title2' : 'title').split('\n');
    const [textT, setTextT] = useState(8);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let n = 8;
            if (window.innerWidth >= 1680) {
                n = 14;
            } else if (window.innerWidth >= 1440) {
                n = 14;
            } else if (window.innerWidth >= 1024) {
                n = 10;
            } else if (window.innerWidth < 1024) {
                n = 6;
                setSpaceBetween(0);
            }
            setTextT(n);

            const sceneKArr: any[] = [];
            // sceneKArr.push(
            //     AniContainer.create({
            //         triggerElement: '.D3A-C',
            //         triggerHook: 1,
            //         onEnter: () => {
            //             setSrc(sources[0]);
            //             setPoster(posters[0]);
            //         },
            //     }),
            // );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.D3A-D',
                    triggerHook: 1,
                    offset: '100%',
                    duration: '30%',
                    asyncFromTo: [
                        [`.D3A-D .icon-ani`, { scale: 0.2 }, { scale: 0.5 }, 0.2],
                        [`.D3A-D .icon-img`, { opacity: 1 }, { opacity: 0.8 }, 0.2],
                        [`.D3A-D .swiper-box`, { opacity: 0 }, { opacity: 0 }, 0.2],
                        [`.D3A-D .icon-ani`, { opacity: 1, scale: 0.5 }, { opacity: 0, scale: 1 }, 0.2],
                        [`.D3A-D .icon-img`, { opacity: 0.8 }, { opacity: 0.5 }, 0.2],
                        [`.D3A-D .swiper-box`, { opacity: 0 }, { opacity: 1 }, 0.2],
                        [`.D3A-D .icon-ani`, { opacity: 0, scale: 1 }, { opacity: 0, scale: 1 }, 0.1],
                        [`.D3A-D .icon-img`, { opacity: 0.5 }, { opacity: 0 }, 0.1],
                        [`.D3A-D .swiper-box`, { opacity: 1 }, { opacity: 1 }, 0.1],
                    ],
                    onEnter: () => { },
                    asyncTimeLine: [0, 0, 0, 0.2, 0.2, 0.2, 0.4, 0.4, 0.4],
                }),
            );

            return () => {
                sceneKArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);
    const { progress, resetProgress } = useAnimationNavigationRight(
        { delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: false, viewport: true, animationNavigationRight: true },
        true,
    );
    useSwiperAutoplayOnVisible(swiperRef, { open: true, resetProgress }, true);
    return (
        <section className={`${css.section} D3A-D D3A-D GtmModuleData-section`} id="D3A-D" data-section-id={'D3A-D'} data-section-title={t('title')}>
            <div className="sticky">
                <div className="swiper-box">
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={0}
                        initialSlide={0}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={isPad ? [Navigation, Thumbs, Autoplay] : [Navigation, Thumbs, Autoplay, EffectFade]}
                        onSwiper={(swiper) => {
                            // setThumbsSwiper(swiper);
                            swiperRef.current = swiper; // 直接获取原生实例
                        }}
                        onTransitionStart={resetProgress}
                        className="swiper-main"
                        effect={'fade'}
                        watchSlidesProgress
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                            viewport: true,
                        }}
                        onSlideChange={(swiper) => {
                            setActive(swiper.activeIndex);

                        }}
                    >
                        {items?.map((item, k) => (
                            <SwiperSlide className="swiper-item" key={k}>
                                <EcoImg className="item-img-main" pc={item.img} pad={item.h5} ></EcoImg>
                                <div className="item-thumb-text-h5">
                                    <div className="card-thumb-title">{items[active].title}</div>
                                    <p className="card-thumb-desc">{items[active].desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                        {/* <div className={`eco-swiper-control`}>
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div> */}
                    </Swiper>
                    <Swiper className="swiper-thumb-box" spaceBetween={spaceBetween} onSwiper={setThumbsSwiper} slidesPerView={'auto'} initialSlide={0}>
                        {items?.map((item: any, k: number) => (
                            <SwiperSlide
                                onClick={() => {
                                    swiperRef?.current?.slideTo(k);
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'tab_click',
                                        list_name: t('title'),
                                        button_name: item.slImg,
                                        __btn_id1: `swiper-thumb-box .item-thumb-img-${k}`,
                                        __btn_id2: item.slImg,
                                        __btn_type: 'text',
                                    });
                                }}
                                className={`swiper-thumb-item ${active === k ? 'active' : ''}`}
                                key={k}
                            >
                                <div className={`item-thumb-img item-thumb-img-${k} GtmModuleData-btn-text`}>
                                    <div className="item-img-box">
                                        <EcoImg className="item-img" pc={item.slImg} ></EcoImg>
                                    </div>
                                    {active === k && (
                                        <div className="progress-container">
                                            <svg width="220" height="120" viewBox="0 0 220 120">
                                                <path
                                                    d="M18,10 H202 A8,8 0 0 1 210,18 V102 A8,8 0 0 1 202,110 H18 A8,8 0 0 1 10,102 V18 A8,8 0 0 1 18,10 Z"
                                                    fill="none"
                                                    stroke="#fff"
                                                    stroke-width="4"
                                                    strokeDasharray={2 * Math.PI * 100}
                                                    strokeDashoffset={2 * Math.PI * 100 * (1 - progress / 100)}
                                                    id={`anim-${k}`}
                                                ></path>
                                            </svg>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="item-thumb-text pc">
                            <div className="card-thumb-title">{items[active]?.title || ''}</div>
                            <p className="card-thumb-desc">{items[active]?.desc || ''}</p>
                        </div>
                    </Swiper>
                </div>
                <div className="icon-box">
                    <div className="icon-ani">
                        <svg width="100%" height="100%" style={{ transform: 'scale(5)' }}>
                            {/* 实心白字（不镂空） */}
                            {lines.map((line: string, index: number) => (
                                <text
                                    className={`svg-text svg-text-${index + 1}`}
                                    key={index}
                                    x="50%"
                                    y={`${50 + (index - (lines.length - 1) / 2) * textT}%`}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    fill="white" // ← 实心白色文字
                                    fontSize="24" // 可按需调整（px 或 SVG 单位）
                                    fontWeight="700"
                                >
                                    {line}
                                </text>
                            ))}
                        </svg>
                    </div>
                    <div className='icon-img'>
                        <EcoImg pc='https://websiteoss.ecoflow.com/upload/image/1763520982058/bg.jpg'></EcoImg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default D;
